module.exports = __webpack_public_path__ + "static/img/burgur-1.008c609.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/burgur-1.png
// module id = efD3
// module chunks = 0